import { Link } from 'react-router';

export function NotFound({ message = 'That page does not exist.' }: { message?: string }) {
  return (
    <div className="page">
      <title>Not found</title>
      <h1>Not found</h1>
      <p>{message}</p>
      <p>
        <Link to="/">Back to the front page</Link>
      </p>
    </div>
  );
}
